// api/linkAPI.js
import { fetchWithAuth } from "@/api/fetchApi";
import { useAuthStore } from "@/stores/authStore"; // 例：Pinia でのログイン情報

export async function getLinkStatus(roomNumber, email) {
  try {
    const res = await fetchWithAuth(`/get-link-status/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        room_number: roomNumber,
        email: email,
      }),
    });

    return res; // { isUserLinking: true/false/null, isRoomLinking: true/false/null }
  } catch (err) {
    console.error("❌ getLinkStatus failed:", err);
    return {
      isUserLinking: null,
      isRoomLinking: null,
    };
  }
}

// ✅ ファイル再生リクエスト（POST /api/trigger-play-if-linked/）
export async function triggerPlayIfLinked(
  roomNumber,
  fileId,
  type = "play",
  options = {}
) {
  try {
    // const payload = {};
    const payload = {
      type, // 例: "play", "pause", "stop", "seek"
      ...options,
    };

    if (roomNumber) payload.room_number = roomNumber;
    if (fileId) payload.file_id = fileId;

    const res = await fetchWithAuth("/trigger-play-if-linked/", {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return res; // { linked: true/false }
  } catch (err) {
    console.error("❌ triggerPlayIfLinked failed:", err);
    return { linked: false };
  }
}

// ✅ 位置合わせリクエスト（POST /api/trigger-anchor/）
// email がある場合は email を優先、なければ room_number を使う
export async function triggerAnchorIfLinked(roomNumber) {
  try {
    const auth = useAuthStore();
    const email = auth?.user?.email;

    const body = email
      ? { email } // 👤 email を優先
      : { room_number: roomNumber }; // 🏠 fallback

    const res = await fetchWithAuth("/trigger-anchor/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return res; // { linked: true/false }
  } catch (err) {
    console.error("❌ triggerAnchorIfLinked failed:", err);
    return { linked: false };
  }
}

// ✅ 位置合わせの完了状態を確認（GET /api/anchor-status/?room_number=xxxxx）
export async function getAnchorStatus(roomNumber) {
  try {
    const res = await fetchWithAuth(
      `/anchor-status/?room_number=${roomNumber}`,
      {
        method: "GET",
      }
    );
    return res; // { is_anchored: true/false }
  } catch (err) {
    console.error("❌ getAnchorStatus failed:", err);
    return { is_anchored: false }; // フォールバック
  }
}
